import { useToast } from '@chakra-ui/react';
import { Alert } from '../components/Alert/Alert';

export const useAlert = () => {
  const toast = useToast();

  const handleToast = (status: 'success' | 'error', message: string) => {
    toast({
      duration: 5000,
      position: 'bottom-left',
      render: () => Alert({ message, status }),
    });
  };

  return handleToast;
};
